import { MouseEventHandler, useMemo } from "react";
import CSS from "./static/css/QuantityControllBtnIcon.module.css";
import IconX from "../IconX/IconX";
import Text from "../../Text/Text";

const QuantityControllBtnIcon = (
    {
        type,
        is_disable,
        onClick,
    }:{
        type: "+" | "-" | "remove"
        is_disable?: boolean;
        onClick?: MouseEventHandler<HTMLDivElement>;
    }
) => {
    const mainClassName = useMemo(() => {
        const RTN: string[] = [];

        RTN.push("g_click_event_item");

        RTN.push(CSS.l_QuantityControllBtnIcon_main)

        if(type === "remove"){
            RTN.push(CSS.remove);
        }
        
        if(is_disable || !onClick){
            RTN.push(CSS.disable);
            RTN.push("not_allowed");
        }

        return RTN.join(" ");
    }, [is_disable, onClick, type])

    return(
        <div 
            className={mainClassName}
            onClick={is_disable ? undefined : onClick}
        >
            {
                type === "remove"
                ?   <IconX preset="medium" />
                :   <Text size={"size7"}>
                        {type}
                    </Text>
            }
        </div>
    )
}

export default QuantityControllBtnIcon;